import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { ErrorHandlerService } from './services/error-handler.service';
import {TranslateService} from '@ngx-translate/core';
import { ChangeLanguageService } from './services/change-language.service';
import { Subscription } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';
import { IconService } from './utilities/icon.services';
import { JoyrideService } from 'ngx-joyride'
import { ClickHistorySubject } from './events/click-history.events';
import { SearchLogClickHistoryModel } from './models/search-log-click-history.model';
import { SearchLogClickHistoryService } from './services/search-log-click-history.service';
import { TR_LOCALE, EN_LOCALE } from './shared/locale.config';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  menuMode = 'horizontal';

  darkMode = 'light';

  topbarTheme = 'light';

  menuTheme = 'light';

  inputStyle = 'outlined';

  ripple: boolean;

  private clickHistorySub: Subscription | null = null;


  langugeSubscription: Subscription;




  constructor(private primengConfig: PrimeNGConfig, private cdr: ChangeDetectorRef, private errorHandlerService: ErrorHandlerService, private searchLogClickHistoryService:SearchLogClickHistoryService, private translation: TranslateService, private readonly joyrideService: JoyrideService, private languageService: ChangeLanguageService, private iconService: IconService ) {
    this.translation.setDefaultLang('en');
    this.translation.use(localStorage.getItem('lang') || 'tr');

    if((localStorage.getItem('lang') || 'tr') == 'tr') {
      this.primengConfig.setTranslation(TR_LOCALE);
    } else {
      this.primengConfig.setTranslation(EN_LOCALE);
    }
    this.iconService.registerIcons();
   }

  ngOnInit() {
    this.primengConfig.ripple = true;
    // this.autoStartTour();


    if(!this.clickHistorySub) {
      this.clickHistorySub = ClickHistorySubject.subscribe((model: SearchLogClickHistoryModel) => {
          console.log("Veri yakalandı: ", model);
          this.searchLogClickHistoryService.create(model).toPromise();
          this.cdr.detectChanges(); // Angular'ı zorla uyandır
      });

    }
    this.langugeSubscription = this.languageService.languageChanged.subscribe(lang => {

      if(lang == 'tr') {
        this.primengConfig.setTranslation(TR_LOCALE);
      } else {
        this.primengConfig.setTranslation(EN_LOCALE);
      }

      console.warn('Language is: ' + lang)
      localStorage.setItem('lang', lang);
    })

    //session uid
    if(!localStorage.getItem('uid')) {
      localStorage.setItem('uid', uuidv4());
    }


  }
  ngOnDestroy(): void {
    if(this.langugeSubscription) this.langugeSubscription.unsubscribe();
    if(this.clickHistorySub) this.clickHistorySub.unsubscribe();
  }

  autoStartTour() {
    const tourOpened = localStorage.getItem('HAS_SEEN_TOUR');

    if (!tourOpened) {
      setTimeout(() => {
        this.joyrideService.startTour({
          steps: [
            'step1',
            'step2',
            'step3',
            'step4',
          ],
          showCounter: true,
          themeColor: '#666',
        }).subscribe({
          complete: () => {

            localStorage.setItem('HAS_SEEN_TOUR', 'true');
          }
        });
      }, 1000);
    }
  }
}
